export const DEBUG = process.env.DEBUG
export const ENABLE_LOGGER = process.env.ENABLE_LOGGER
export const QINIU_SERVER = '//qn.saiday.com/'



// WEBPACK FOOTER //
// ./client/config.js